import { registerCardType } from './registry.js';
import { basic, reversed } from './basic.js';
import { cloze } from './cloze.js';
import { typein } from './typein.js';
import { mcq } from './mcq.js';

[basic, reversed, cloze, typein, mcq].forEach(registerCardType);

export * from './registry.js';
